import React, { Component } from "react";
import classNames from "classnames";
import { string, func, bool, node } from "prop-types";

import I18n from "pages/_components/I18n";
import FieldError from "pages/_components/fields/FieldError";

class SwitchField extends Component {
    static propTypes = {
        name: string,
        onChange: func,
        onBlur: func,
        error: string,
        label: string,
        hideLabel: bool,
        idForm: string,
        readOnly: bool,
        value: bool,
        formGroup: string,
        biggerLabel: bool,
        notMb: bool,
        isDisabled: bool,
        buttonInfo: node,
    };

    static defaultProps = {
        name: "",
        error: "",
        label: "",
        hideLabel: false,
        idForm: "",
        readOnly: false,
        value: false,
        onChange: () => {},
        onBlur: null,
        formGroup: "",
        biggerLabel: false,
        notMb: false,
        isDisabled: false,
        buttonInfo: null,
    };

    handleChange = ({ target, ...event }) => {
        const { onChange, isDisabled } = this.props;

        if (!isDisabled) {
            onChange({
                ...event,
                target: {
                    ...target,
                    value: target.value === "true",
                },
            });
        }
    };

    render() {
        const {
            idForm,
            error,
            hideLabel,
            label,
            value,
            formGroup,
            biggerLabel,
            notMb,
            isDisabled,
            buttonInfo,
            ...props
        } = this.props;

        return (
            <div
                className={classNames("c-control c-control-block c-control--switch", {
                    "form-group": formGroup,
                    "has-error": error,
                    "mb-0": notMb,
                    "control-label-disable": isDisabled,
                    "d-flex align-items-center": buttonInfo !== null,
                })}>
                <input
                    id={props.name}
                    className="c-control-input"
                    type="checkbox"
                    {...props}
                    onChange={this.handleChange}
                    value={!value}
                    checked={value}
                    readOnly
                />
                <label className="c-control-label" htmlFor={props.name}>
                    {!hideLabel && !biggerLabel && (
                        <div className="form-group-text m-0">
                            {label || <I18n id={`${idForm}.${props.name}.label`} />}
                        </div>
                    )}
                    {!hideLabel && biggerLabel && (
                        <h4 className="table-legend">{label || <I18n id={`${idForm}.${props.name}.label`} />}</h4>
                    )}
                </label>
                {buttonInfo}
                {error && <FieldError error={error} />}
            </div>
        );
    }
}

export default SwitchField;
